<div
  class="job-status"
>
  <mat-tab-group
    (click)="$event.stopPropagation()"
    (keydown)="null"
  >
    <mat-tab
      [label]="'TRANS__JOB_STATUS__YOUR_OPERATIONS' | translate"
    >
      <div
        class="job-status__list"
      >
        @for(job of userJobs; track $index) {
          <app-job-status-item
            [message]="job"
          />
        }
      </div>
    </mat-tab>

    @if (userIsAdmin) {
      <mat-tab
        [label]="'TRANS__JOB_STATUS__ALL_OPERATIONS' | translate"
      >
        <div
          class="job-status__list"
        >
          @for(job of allJobs; track $index) {
            <app-job-status-item
              [message]="job"
            />
          }
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
